<template>
  <div :class="$style.fileContainer">
    <div :class="$style.fileMain">
      <app-loader :show-loader="getLoadingStatus"/>
      <vue-custom-scrollbar class="scroll-area"
                            :settings="settings">
        <div :class="$style.filing">
          <div :class="$style.imageContainer">
            <img src="@/assets/img/ic_cover_qualify.png" alt="Qualify" />
          </div>

          <h1 :class="$style.filingTitle">
            <span>Filing Decision</span>
          </h1>
          <h6>How would you like to proceed?</h6>

          <div :class="$style.decisionContainer">

            <div v-if="getQualifyStatus && getQualifyStatus.irsAvailable"
                 :class="[$style.decisionOption, getDecisionOptionStyle]">

              <div :class="$style.optionMain">
                <h2>I will contact the IRS by myself</h2>
                <p :class="$style.description">Get all the right tools to do it yourself</p>

                <div :class="$style.price">
                  <h4>No Additional Charge</h4>
                </div>

                <div :class="$style.info">
                  <p>
                    All the forms and information you need to successfully negotiate a
                    tax settlement with the IRS yourself will be provided!
                  </p>
                  <p>
                    You must contact or visit your local IRS office, present your offer
                    and conduct your own Tax Resolution negotiations.
                  </p>
                </div>
              </div>

              <app-button text="Get Started"
                          button-style="accent"
                          :class="$style.startButton"
                          @click="chooseContactOneself"/>

            </div>

            <div v-if="getQualifyStatus && getQualifyStatus.negotiatorServicesAvailable"
                 :class="[$style.decisionOption, getDecisionOptionStyle]">

              <div :class="$style.optionMain">
                <div :class="$style.recommended">
                  <span>Recommended</span>
                </div>
                <h2>EZTX&reg; Professional Negotiator Services</h2>
                <p :class="$style.description">
                  The simple and efficient way to negotiate with the IRS
                </p>
                <p :class="$style.condition">
                  If you have a bank and/or payroll levy, or owe in excess of $100,000
                  then this is the EZTX&reg; fee to professionally represent you before the IRS.
                </p>

                <div :class="$style.price">
                  <h4>{{ price | currency }}</h4>
                </div>

                <div :class="$style.info">
                  <p>
                    Our tax professionals will negotiate your tax relief.
                    We have direct IRS access and can expedite your resolution!
                  </p>
                </div>
              </div>

              <app-button text="Get Started"
                          button-style="accent"
                          :class="$style.startButton"
                          @click="chooseEasyFiling"/>
            </div>

            <div v-if="getQualifyStatus && !getQualifyStatus.negotiatorServicesAvailable">
              <app-info-block :icon-top="true">
                <p>
                  It is our company policy to use a qualified tax attorney to speak with the IRS for
                  the sum of money owed. It is a requirement to provide full financial disclosures
                  and documentation. The IRS will assign a collections agent to your case and you
                  will have to speak to them in person. It is in your absolute best financial
                  interest to use a qualified tax attorney to represent you before the IRS. You
                  must sign a Power of Attorney, which requires the IRS to talk to us and not you.
                  Please click here <a href="mailto:taxattorney@eztx.com">taxattorney@eztx.com</a>
                  to contact an EZTX&reg; attorney to understand your options.
                </p>
                <p>
                  IRS Revenue officers are the most senior of agents. They are highly trained
                  and will use a number of tactics to resolve your delinquent account in the
                  favor of the IRS. They can retrieve 3rd party records through summons and
                  show up at your home or work and legally seize a variety of assets.
                </p>
              </app-info-block>
            </div>
          </div>

        </div>
      </vue-custom-scrollbar>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import VueCustomScrollbar from 'vue-custom-scrollbar';

export default {
  components: {
    VueCustomScrollbar,
  },
  data() {
    return {
      settings: {
        wheelSpeed: 0.5,
      },
      price: 0,
      proofsRequired: false,
      resultType: 0,
    };
  },
  methods: {
    ...mapActions([
      'fetchQualifyStatus',
      'postFilingDecision',
      'getFormProgress',
    ]),
    ...mapMutations([
      'setBackToDecisionPermission',
    ]),
    chooseEasyFiling() {
      this.setBackToDecisionPermission(false);
      this.postFilingDecision({
        userId: this.getUserId,
        filingType: 0,
      }).then(() => {
        this.getFormProgress(this.getUserId);
        if (this.getIsCPA) {
          this.$router.push({
            params: { id: this.getCPAId },
            name: 'proofs',
          }).catch(error => console.error(error));
        } else {
          this.$router.push({ name: 'payment', query: { paymentType: 'eztx' } }).catch(() => {});
        }
      });
    },
    chooseContactOneself() {
      this.setBackToDecisionPermission(false);
      this.postFilingDecision({
        userId: this.getUserId,
        filingType: 1,
      }).then(() => {
        this.getFormProgress(this.getUserId);
        this.$router.push({
          params: { id: this.getCPAId },
          name: 'manual',
        }).catch(error => console.error(error));
      });
    },
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getQualifyStatus',
      'getQualifyLoadingStatus',
      'getFilingDecisionStatus',
      'getCPAId',
      'getIsCPA',
    ]),
    getLoadingStatus() {
      return this.getQualifyLoadingStatus === 'loading' || this.getFilingDecisionStatus === 'loading';
    },
    getDecisionOptionStyle() {
      if (!this.getQualifyStatus.irsAvailable) {
        return this.$style.fullWidth;
      }

      return this.$style.halfWidth;
    },
  },
  created() {
    this.fetchQualifyStatus(this.getUserId)
      .then(() => {
        this.price = this.getQualifyStatus.eztxPricing;
        this.proofsRequired = this.getQualifyStatus.proofsRequired;
        this.resultType = this.getQualifyStatus.type;
      });
  },
};
</script>

<style lang="scss" module>
@import "~@/styles/variables.scss";

.fileContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-height: 100vh;

  .fileMain {
    max-height: 100%;
  }
}

.filing {
  padding: 40px;
  text-align: center;
}

.imageContainer {
  width: 100%;
  text-align: center;
}

.filingTitle {
  span {
    position: relative;
    padding: 0 27px;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      height: 4px;
      background-color: $wizard-title-color;
      width: 125px;
    }

    &::before {
      left: -125px;
    }

    &::after {
      right: -125px;
    }
  }
}

.decisionContainer {
  width: 100%;
  display: flex;
  align-items: stretch;
  margin-top: 24px;

  .decisionOption {
    background-color: $white-color;
    box-shadow: $images-shadow;
    padding: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;

    &.fullWidth {
      margin: 0 auto;
      width: 100%;
      max-width: 500px;
    }

    &.halfWidth {
      margin: 0 30px;
      width: calc(50% - 60px); /* half-width minus side margins */
    }
  }

  .recommended {
    position: absolute;
    top: 20px;
    left: 0;
    width: 100%;
    text-align: center;

    span {
      background-color: $accent-color;
      color: $white-color;
      padding: 4px 9px;
      border-radius: 10px;
      font-size: 1.1rem;
      font-family: $title-font;
      font-style: italic;
    }
  }
}

.optionMain {

  h2 {
    text-align: center;
  }

  .description {
    font-family: $main-font;
    color: $main-text-color;
    font-style: italic;
    font-size: 1.3rem;
    text-align: center;
    margin-bottom: 0;
  }

  .condition {
    font-family: $main-font;
    color: $main-text-color;
    font-style: italic;
    font-size: 1.3rem;
    line-height: 1.8rem;
    text-align: center;
    margin-bottom: 0;
  }

  .price {
    margin: 20px 32px 20px;
    border-top: 3px solid $radio-active-color;
    border-bottom: 3px solid $radio-active-color;
    padding: 16px;
    text-align: center;
  }

  .info {
     p {
       font-family: $main-font;
       color: $main-text-color;
       font-style: italic;
       font-size: 1.3rem;
       line-height: 1.8rem;
       text-align: left;
       margin-bottom: 10px;
     }
  }
}

.startButton {
  width: 100%;
  padding: 10px 0;
}
</style>

<style lang="scss">
@import "@/styles/variables.scss";

.scroll-area {
  width: 100%;
  height: 100%;
  max-height: 100%;
}

.ps:hover > .ps__rail-y {
  opacity: 1;
}
.ps__thumb-x,
.ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y:hover > .ps__thumb-y {
  background-color: $radio-active-color;
}
</style>
